export interface InsertionState {
  anchor: number; // index where the current utterance begins
  interimLen: number; // length of the not-yet-committed interim text
}

export interface QuillOps {
  deleteText: (index: number, length: number) => void;
  insertText: (index: number, text: string) => void;
  setSelection: (index: number) => void;
}

export function applyInterim(
  ops: QuillOps,
  state: InsertionState,
  text: string,
): InsertionState {
  ops.deleteText(state.anchor, state.interimLen);
  ops.insertText(state.anchor, text);
  ops.setSelection(state.anchor + text.length);
  return { anchor: state.anchor, interimLen: text.length };
}

export function applyFinal(
  ops: QuillOps,
  state: InsertionState,
  text: string,
): InsertionState {
  ops.deleteText(state.anchor, state.interimLen);
  const committed = text.endsWith(' ') ? text : `${text} `;
  ops.insertText(state.anchor, committed);
  const anchor = state.anchor + committed.length;
  ops.setSelection(anchor);
  return { anchor, interimLen: 0 };
}

